export const USER_LOCKED = 'USER_LOCKED';
export const USER_LOCKED_NOW = 'USER_LOCKED_NOW';
export const USER_BLOCKED = 'USER_BLOCKED';
